var _style, _path, _g, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoScantripWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "191.8px",
    height: "30px",
    viewBox: "0 0 191.8 30",
    style: {
      enableBackground: "new 0 0 191.8 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000021809573096534166250000015096889096378187431_);}\r\n\t\r\n\t\t.st2{display:none;clip-path:url(#SVGID_00000111172750178904018330000010866152681156028812_);fill:url(#SVGID_00000047739193697153076440000015413397443565886129_);}\r\n\t.st3{display:none;clip-path:url(#SVGID_00000127751344304491033640000003861489752406491013_);fill:#F0E3FC;}\r\n\t\r\n\t\t.st4{clip-path:url(#SVGID_00000065044742331890180300000003767011104728414344_);fill:url(#SVGID_00000129188241984547385970000009739829612320404112_);}\r\n\t.st5{clip-path:url(#SVGID_00000104668146109627313540000012270109365846885797_);fill:#F0E3FC;}\r\n\t\r\n\t\t.st6{clip-path:url(#SVGID_00000144319906787298536110000007417196587548050331_);fill:url(#SVGID_00000102514868733670610010000007018661465765078661_);}\r\n\t.st7{clip-path:url(#SVGID_00000031166769574986495320000012407576756992715958_);fill:#F0E3FC;}\r\n\t.st8{fill:url(#SVGID_00000086674357265358284930000017979382141589916602_);}\r\n\t.st9{fill:url(#SVGID_00000109708663380719858300000011708204776646840507_);}\r\n\t.st10{fill:url(#SVGID_00000058563498668171801730000008616000771394694065_);}\r\n\t.st11{fill:url(#SVGID_00000112634774757899823580000006878787523592482446_);}\r\n\t.st12{fill:url(#SVGID_00000067220660913003165190000014567899368943340965_);}\r\n\t.st13{fill:url(#SVGID_00000095306637061351559820000009975624614607103666_);}\r\n\t.st14{enable-background:new    ;}\r\n\t.st15{fill:#FFFFFF;}\r\n\t.st16{fill:#38256E;}\r\n\t.st17{display:none;fill:#FFFFFF;}\r\n\t.st18{fill:none;stroke:#38256E;stroke-width:0.2363;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000075847439931927493540000010881132992735005371_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.1898,
    y1: 30.1889,
    x2: 21.7088,
    y2: 2.6323,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#652D90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262261"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.7,28.6c0,0.3-0.3,0.5-0.7,0.5H10.9c-0.4,0-0.7-0.2-0.7-0.5V2.5c0-0.3,0.3-0.5,0.7-0.5H33 c0.4,0,0.7,0.2,0.7,0.5V28.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116198473441273048440000002328450951515986840_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.95,
    y1: 3.6,
    x2: 21.95,
    y2: 29.2631,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#652D90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001469358,
    style: {
      stopColor: "#6A3597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003767386,
    style: {
      stopColor: "#7A4BA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006590164,
    style: {
      stopColor: "#926FC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008379889,
    style: {
      stopColor: "#A48ADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008379889,
    style: {
      stopColor: "#A48ADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D61BC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116198473441273048440000002328450951515986840_)"
    },
    d: "M33.1,27.9c0,0.3-0.3,0.5-0.7,0.5H11.5 c-0.4,0-0.7-0.2-0.7-0.5V3.3c0-0.3,0.3-0.5,0.7-0.5h20.9c0.4,0,0.7,0.2,0.7,0.5C33.1,3.3,33.1,27.9,33.1,27.9z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116920272773597213240000009092710120826021773_",
    d: "M33.1,27.9c0,0.3-0.3,0.5-0.7,0.5H11.5 c-0.4,0-0.7-0.2-0.7-0.5V3.3c0-0.3,0.3-0.5,0.7-0.5h20.9c0.4,0,0.7,0.2,0.7,0.5C33.1,3.3,33.1,27.9,33.1,27.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018953074312646712140000007715521554590237322_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116920272773597213240000009092710120826021773_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000170263979218914972580000016447277389371197619_",
    cx: 22.5571,
    cy: 5.9882,
    r: 9.7014,
    gradientTransform: "matrix(1 0 0 -1 0 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#652D90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2315,
    style: {
      stopColor: "#5D2C8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5934,
    style: {
      stopColor: "#472879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262261"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      clipPath: "url(#SVGID_00000018953074312646712140000007715521554590237322_)",
      fill: "url(#SVGID_00000170263979218914972580000016447277389371197619_)"
    },
    d: " M35.5,30.6c0-0.1,0-0.2,0-0.2c0-2-2.2-3.7-5-3.7c0.1-0.2,0.1-0.4,0.1-0.6c0-1.3-1.4-2.3-3.2-2.3c-0.4,0-0.9,0.1-1.3,0.2 c-0.4-1.4-2.1-2.4-4.2-2.4c-2.4,0-4.3,1.4-4.3,3.1l0,0c-0.1,0-0.2,0-0.3,0c-1.7,0-3.2,0.9-3.5,2.1c-0.1,0-0.3,0-0.4,0 c-2.1,0-3.9,1.2-3.9,2.8c0,0.4,0.1,0.8,0.4,1.2h25.6V30.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000029013245805813916560000012558732627943110292_",
    d: "M33.1,27.9c0,0.3-0.3,0.5-0.7,0.5H11.5 c-0.4,0-0.7-0.2-0.7-0.5V3.3c0-0.3,0.3-0.5,0.7-0.5h20.9c0.4,0,0.7,0.2,0.7,0.5C33.1,3.3,33.1,27.9,33.1,27.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130618304909126253050000013666378197272379534_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029013245805813916560000012558732627943110292_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      clipPath: "url(#SVGID_00000130618304909126253050000013666378197272379534_)",
      fill: "#F0E3FC"
    },
    d: " M35.2,30.8c0-0.1,0-0.2,0-0.2c0-2-2.2-3.7-5-3.7c0.1-0.2,0.1-0.4,0.1-0.6c0-1.3-1.4-2.3-3.2-2.3c-0.4,0-0.9,0.1-1.3,0.2 c-0.4-1.4-2.1-2.4-4.2-2.4c-2.4,0-4.3,1.4-4.3,3.1l0,0c-0.1,0-0.2,0-0.3,0c-1.7,0-3.2,0.9-3.5,2.1c-0.1,0-0.3,0-0.4,0 c-2.1,0-3.9,1.2-3.9,2.8c0,0.4,0.1,0.8,0.4,1.2h25.6V30.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000051375621166407340540000016603104222203554202_",
    d: "M33.1,27.9c0,0.3-0.3,0.5-0.7,0.5H11.5 c-0.4,0-0.7-0.2-0.7-0.5V3.3c0-0.3,0.3-0.5,0.7-0.5h20.9c0.4,0,0.7,0.2,0.7,0.5C33.1,3.3,33.1,27.9,33.1,27.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130617818169266032470000004708633155482195844_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051375621166407340540000016603104222203554202_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000127027164660469429660000002579192802219894147_",
    cx: 27.1412,
    cy: 4.6164,
    r: 9.3049,
    gradientTransform: "matrix(1 0 0 -1 0 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#652D90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2315,
    style: {
      stopColor: "#5D2C8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5934,
    style: {
      stopColor: "#472879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262261"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130617818169266032470000004708633155482195844_)",
      fill: "url(#SVGID_00000127027164660469429660000002579192802219894147_)"
    },
    d: " M39.4,29.5c0-1.5-1.2-2.8-2.8-2.8c-0.3,0-0.6,0-0.8,0.1c-0.5-1.5-1.8-2.6-3.5-2.6c-0.9,0-1.8,0.4-2.4,0.9c-0.6-1.5-2-2.5-3.7-2.5 s-3.2,1.1-3.8,2.6c-1.6,0.1-2.8,1.3-3,2.8c-0.2,0-0.4-0.1-0.6-0.1c-1,0-1.9,0.7-2.3,1.6c-0.1,0-0.2,0-0.2,0 c-0.9,0-1.6,0.7-1.6,1.6c0,0.3,0.1,0.6,0.2,0.8h22.8l0,0C38.8,31.6,39.4,30.6,39.4,29.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000098921289238833163390000003523470335982785206_",
    d: "M33.1,27.9c0,0.3-0.3,0.5-0.7,0.5H11.5 c-0.4,0-0.7-0.2-0.7-0.5V3.3c0-0.3,0.3-0.5,0.7-0.5h20.9c0.4,0,0.7,0.2,0.7,0.5C33.1,3.3,33.1,27.9,33.1,27.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003815597340244286730000013573902304024103335_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098921289238833163390000003523470335982785206_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000003815597340244286730000013573902304024103335_)",
      fill: "#F0E3FC"
    },
    d: "M39.3,29.7 c0-1.5-1.2-2.8-2.8-2.8c-0.3,0-0.6,0-0.8,0.1c-0.5-1.5-1.8-2.6-3.5-2.6c-0.9,0-1.8,0.4-2.4,0.9c-0.6-1.5-2-2.5-3.7-2.5 s-3.2,1.1-3.8,2.6c-1.6,0.1-2.8,1.3-3,2.8c-0.2,0-0.4-0.1-0.6-0.1c-1,0-1.9,0.7-2.3,1.6c-0.1,0-0.2,0-0.2,0 c-0.9,0-1.6,0.7-1.6,1.6c0,0.3,0.1,0.6,0.2,0.8h22.8l0,0C38.6,31.7,39.3,30.8,39.3,29.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000050659307475430119150000014591550233529075585_",
    d: "M33.1,27.9c0,0.3-0.3,0.5-0.7,0.5H11.5 c-0.4,0-0.7-0.2-0.7-0.5V3.3c0-0.3,0.3-0.5,0.7-0.5h20.9c0.4,0,0.7,0.2,0.7,0.5C33.1,3.3,33.1,27.9,33.1,27.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119110932303105155390000013166396016519611288_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050659307475430119150000014591550233529075585_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000054242507326722476200000018318416356106798500_",
    cx: 18.5176,
    cy: 5.95,
    r: 9.2993,
    gradientTransform: "matrix(1 0 0 -1 0 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#652D90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2315,
    style: {
      stopColor: "#5D2C8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5934,
    style: {
      stopColor: "#472879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262261"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119110932303105155390000013166396016519611288_)",
      fill: "url(#SVGID_00000054242507326722476200000018318416356106798500_)"
    },
    d: " M7.8,30.7L7.8,30.7h22.8c0.1-0.2,0.2-0.5,0.2-0.8c0-0.9-0.7-1.6-1.6-1.6c-0.1,0-0.2,0-0.2,0c-0.3-0.9-1.2-1.6-2.3-1.6 c-0.2,0-0.4,0-0.6,0.1c-0.2-1.5-1.4-2.7-3-2.8c-0.6-1.5-2-2.6-3.8-2.6c-1.7,0-3.1,1-3.7,2.5C15,23.4,14.2,23,13.2,23 c-1.6,0-3,1.1-3.5,2.6c-0.3-0.1-0.5-0.1-0.8-0.1c-1.5,0-2.8,1.2-2.8,2.8C6.2,29.3,6.9,30.3,7.8,30.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000111907342772754883050000009567797963568365212_",
    d: "M33.1,27.9c0,0.3-0.3,0.5-0.7,0.5H11.5 c-0.4,0-0.7-0.2-0.7-0.5V3.3c0-0.3,0.3-0.5,0.7-0.5h20.9c0.4,0,0.7,0.2,0.7,0.5C33.1,3.3,33.1,27.9,33.1,27.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010989029559804068660000017271674686426896060_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111907342772754883050000009567797963568365212_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000010989029559804068660000017271674686426896060_)",
      fill: "#F0E3FC"
    },
    d: "M7.6,30.9L7.6,30.9 h22.8c0.1-0.2,0.2-0.5,0.2-0.8c0-0.9-0.7-1.6-1.6-1.6c-0.1,0-0.2,0-0.2,0c-0.3-0.9-1.2-1.6-2.3-1.6c-0.2,0-0.4,0-0.6,0.1 c-0.2-1.5-1.4-2.7-3-2.8c-0.6-1.5-2-2.6-3.8-2.6c-1.7,0-3.1,1-3.7,2.5c-0.6-0.6-1.5-0.9-2.4-0.9c-1.6,0-3,1.1-3.5,2.6 c-0.3-0.1-0.5-0.1-0.8-0.1c-1.5,0-2.8,1.2-2.8,2.8C5.9,29.5,6.6,30.5,7.6,30.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001644519330085478660000011186033470008206247_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.299,
    y1: 21.45,
    x2: 2.0277,
    y2: 21.45,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001644519330085478660000011186033470008206247_)"
    },
    d: "M2,15.2c0,0,7.7-9.3,20-9.3 s19.2,9.3,19.2,9.3S32,8.1,22,8.1C11.9,8.1,2,15.2,2,15.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106115015563042020000000016727107578163890603_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.8,
    y1: 15.4,
    x2: 3.5,
    y2: 15.4,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106115015563042020000000016727107578163890603_)"
    },
    d: "M3.5,20.9c0,0,7.2-8.6,18.5-8.6 s17.8,8.6,17.8,8.6s-8.6-6.8-17.9-6.8C12.7,14.1,3.5,20.9,3.5,20.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133513228027455069960000015101617395873327512_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.2,
    y1: 10.6,
    x2: 5.2,
    y2: 10.6,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133513228027455069960000015101617395873327512_)"
    },
    d: "M5.2,25c0,0,6.5-7.2,16.8-7.2 S38.2,25,38.2,25s-8.1-5.7-16.5-5.7C13.2,19.2,5.2,25,5.2,25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008120594154950515440000016126513291550163621_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.8,
    y1: 22.05,
    x2: 40.5,
    y2: 22.05,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008120594154950515440000016126513291550163621_)"
    },
    d: "M2.8,14.4c0,0,7.4-8.9,19.2-8.9 s18.5,8.9,18.5,8.9S31.6,7.6,22,7.6C12.3,7.6,2.8,14.4,2.8,14.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136392988530586978220000005676773562411688354_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.2354,
    y1: 16.25,
    x2: 39.0912,
    y2: 16.25,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136392988530586978220000005676773562411688354_)"
    },
    d: "M4.2,19.9c0,0,6.9-8.3,17.8-8.3 s17.1,8.3,17.1,8.3s-8.3-6.5-17.2-6.5S4.2,19.9,4.2,19.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106112100250644688700000011188080935871891337_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.8,
    y1: 11.65,
    x2: 37.5,
    y2: 11.65,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106112100250644688700000011188080935871891337_)"
    },
    d: "M5.8,23.8c0,0,6.3-6.9,16.2-6.9 s15.5,6.9,15.5,6.9s-7.7-5.5-15.8-5.5S5.8,23.8,5.8,23.8z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M45.1,1.8h4.6c3.4,0,4.9,2.5,4.9,5.5s-1.5,5.5-4.9,5.5h-4.6V1.8z M47.1,11.3H49c3,0,3.7-1.7,3.7-3.9 S52,3.4,49,3.4h-1.9V11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M56.1,1.8h1.8v1.7h-1.8V1.8z M56.1,4.9h1.8v8h-1.8V4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M61.2,10.3c0.1,1,0.9,1.4,1.8,1.4c0.7,0,1.8-0.1,1.8-1.1c0-0.9-1.3-1-2.6-1.3C60.8,9,59.6,8.6,59.6,7 c0-1.8,1.9-2.3,3.3-2.3c1.6,0,3.1,0.7,3.3,2.5h-1.8c-0.2-0.8-0.9-1.1-1.6-1.1c-0.5,0-1.5,0.1-1.5,0.8c0,0.9,1.3,1,2.6,1.3 c1.3,0.3,2.6,0.8,2.6,2.3c0,1.9-1.9,2.6-3.6,2.6c-2,0-3.5-0.9-3.5-2.8H61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M67.9,4.9h1.7V6h0c0.5-0.9,1.5-1.3,2.5-1.3c2.5,0,3.7,1.9,3.7,4.3c0,2.2-1.1,4.2-3.5,4.2 c-1,0-2.1-0.4-2.7-1.3h0v4h-1.8V4.9z M71.9,6.1c-1.5,0-2.2,1.1-2.2,2.8c0,1.6,0.8,2.8,2.2,2.8c1.6,0,2.2-1.4,2.2-2.8 C74.1,7.4,73.3,6.1,71.9,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84,11.1c0,0.4,0.1,0.6,0.4,0.6c0.1,0,0.2,0,0.4,0v1.2c-0.3,0.1-0.8,0.2-1.1,0.2c-0.7,0-1.2-0.2-1.4-1 c-0.7,0.7-1.8,1-2.8,1c-1.4,0-2.7-0.8-2.7-2.3c0-2,1.6-2.3,3.1-2.5c1.3-0.2,2.4-0.1,2.4-1.1c0-0.9-0.9-1.1-1.7-1.1 c-1,0-1.7,0.4-1.8,1.3h-1.8c0.1-2.1,1.9-2.7,3.6-2.7C82.4,4.7,84,5.3,84,7V11.1z M82.3,8.9c-0.5,0.4-1.4,0.3-2.2,0.5 c-0.8,0.1-1.4,0.4-1.4,1.3c0,0.8,1,1,1.6,1c0.8,0,2-0.4,2-1.5V8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M85.1,4.9h1.3V2.5h1.8v2.4h1.6v1.3h-1.6v4.3c0,0.7,0.1,1.1,0.9,1.1c0.2,0,0.5,0,0.7-0.1v1.4 c-0.4,0-0.8,0.1-1.1,0.1c-1.8,0-2.2-0.7-2.2-2V6.2h-1.3V4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M96.5,7.6c-0.1-1-0.9-1.5-1.8-1.5c-0.9,0-2.2,0.5-2.2,2.9c0,1.3,0.6,2.7,2.1,2.7c1,0,1.7-0.7,1.9-1.8h1.8 c-0.3,2.1-1.6,3.2-3.7,3.2c-2.5,0-3.9-1.8-3.9-4.1c0-2.4,1.3-4.3,3.9-4.3c1.9,0,3.4,0.9,3.6,2.9H96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M99.7,1.8h1.8v4.1h0c0.4-0.7,1.3-1.3,2.4-1.3c1.7,0,2.8,0.9,2.8,2.7v5.5H105v-5c0-1.3-0.5-1.8-1.6-1.8 c-1.2,0-1.9,0.9-1.9,2.1v4.7h-1.8V1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M110,9.3c0,1.3,0.7,2.4,2.2,2.4c1,0,1.6-0.4,2-1.3h1.7c-0.4,1.8-1.9,2.7-3.6,2.7c-2.5,0-3.9-1.8-3.9-4.2 c0-2.3,1.5-4.2,3.9-4.2c2.5,0,4.1,2.3,3.8,4.7H110z M114.1,8.2c-0.1-1.1-0.8-2.1-2-2.1c-1.2,0-2.1,0.9-2.1,2.1H114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M117.2,4.9h1.7v1.5h0c0.2-0.9,1.3-1.8,2.3-1.8c0.4,0,0.5,0,0.7,0v1.7c-0.2,0-0.5-0.1-0.8-0.1 c-1.2,0-2.2,1-2.2,2.7v3.8h-1.8V4.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M75.5,19c0-1.8-1-2.4-2.7-2.4c-1.3,0-2.6,0.6-2.6,2.1c0,1.1,0.9,1.5,1.7,1.7l1.1,0.3 c1.4,0.4,2.7,0.9,2.7,2.7c0,1-0.6,3.2-3.9,3.2c-2.3,0-4-1.1-3.8-3.7h1c-0.1,2,1.1,2.8,2.9,2.8c1.3,0,2.9-0.7,2.9-2.3 c0-1.5-1.4-1.8-2.5-2.1l-1-0.3c-1.2-0.4-2-1.1-2-2.4c0-2.1,1.8-3,3.6-3c2.1,0,3.7,0.9,3.6,3.3H75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M82.9,21.2c0.1-1.1-0.7-1.8-1.8-1.8c-2.2,0-3.2,2.1-3.2,4.1c0,1.4,0.7,2.4,2.1,2.4c1.2,0,2-0.8,2.4-1.9h0.9 c-0.5,1.7-1.7,2.7-3.4,2.7c-1.8,0-2.8-1.3-2.8-3.1c0-2.4,1.5-4.9,4-4.9c1.6,0,2.8,0.8,2.8,2.6H82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M85.1,21.1c0.2-1.7,1.5-2.5,3.1-2.5c1,0,2.6,0.4,2.6,1.7c0,0.7-0.3,1.9-0.5,2.6c-0.3,1.7-0.5,2.1-0.5,2.6 c0,0.3,0.3,0.3,0.5,0.3c0.1,0,0.2,0,0.4,0l-0.1,0.7c-0.2,0-0.5,0.1-0.7,0.1c-0.5,0-0.8-0.3-0.8-0.8c0-0.1,0-0.3,0-0.4l0,0 c-0.5,0.9-1.5,1.4-2.6,1.4c-1.3,0-2.4-0.6-2.4-2.1c0-1.6,1.2-2.1,2.6-2.4c0.9-0.1,1.8-0.1,2.3-0.2c0.6-0.1,0.9-0.5,0.9-1.5 c0-0.9-0.9-1.1-1.6-1.1c-1.1,0-2.1,0.4-2.3,1.7H85.1z M89.5,22.4L89.5,22.4c-0.3,0.3-1.2,0.4-1.7,0.4C86.8,22.9,85,23,85,24.5 c0,1,0.8,1.4,1.6,1.4c1.4,0,2.4-0.9,2.6-2.2L89.5,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M93,18.9h0.8l-0.3,1.4h0c0.6-0.9,1.5-1.6,2.6-1.6c1.3,0,2.2,0.6,2.2,2c0,0.2,0,0.5-0.1,0.9l-1,4.9h-0.9 l1-4.9c0.1-0.2,0.1-0.5,0.1-0.8c0-1-0.7-1.4-1.5-1.4c-1.3,0-2.5,1.2-2.9,3.1l-0.8,3.9h-0.9L93,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M100.4,16h8l-0.2,0.9h-3.5l-2,9.6h-1l2-9.6h-3.5L100.4,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M107.3,18.9h0.8l-0.4,1.8h0c0.6-1.1,1.4-1.9,2.7-1.9c0.2,0,0.3,0,0.5,0l-0.2,0.9c-0.2,0-0.3,0-0.5,0 c-1.6,0-2.5,1.4-2.8,2.8l-0.8,4h-0.9L107.3,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M111.8,18.9h0.9l-1.6,7.6h-0.9L111.8,18.9z M112.4,16h0.9l-0.3,1.5h-0.9L112.4,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M114.5,18.9h0.8l-0.3,1.4h0c0.6-1,1.4-1.6,2.7-1.6c1.9,0,2.8,1.2,2.8,3.1c0,2.3-1.6,4.9-4,4.9 c-1.2,0-2.2-0.5-2.4-1.7h0l-0.9,4.3h-0.9L114.5,18.9z M114.5,23.7c0,1.3,0.7,2.2,2.1,2.2c2.1,0,3.1-2.4,3.1-4.2 c0-1.3-0.6-2.3-2-2.3C115.6,19.4,114.5,21.8,114.5,23.7z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 13.6,
    className: "st16",
    width: 50.1,
    height: 15.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M111.3,15.9c2.7,0,4.5,1.9,4.5,4.5c0,4.3-2.7,6.3-5.5,6.3c-2.9,0-4.6-1.9-4.6-4.5 C105.7,17.8,108.6,15.9,111.3,15.9z M110.4,25.2c2.4,0,3.6-2.5,3.6-4.8c0-1.9-1-3.1-2.8-3.1c-2.5,0-3.7,2.5-3.7,4.8 C107.5,24,108.6,25.2,110.4,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M136.8,19.6c0-1.4-0.9-2.2-2.3-2.2c-2.5,0-3.7,2.5-3.7,4.8c0,1.9,1,3.1,2.8,3.1c1.9,0,2.5-1.7,2.7-2.4h1.8 c-0.6,2.6-2.4,3.8-4.5,3.8c-2.9,0-4.6-1.9-4.6-4.5c0-4.3,2.8-6.3,5.5-6.3c2.4,0,4.1,1.3,4.1,3.7H136.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M140.9,16.1h1.6l-2.1,10.3h-1.6L140.9,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M142.6,23.4c0-2.5,1.7-4.6,4.3-4.6c2,0,3.3,1.1,3.3,3.2c0,2.6-1.6,4.7-4.3,4.7 C143.8,26.6,142.6,25.4,142.6,23.4z M144.3,23.4c0,1.1,0.5,1.9,1.7,1.9c1.7,0,2.5-1.8,2.5-3.3c0-1.1-0.5-1.9-1.7-1.9 C145.1,20.1,144.3,21.9,144.3,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M157.3,26.4h-1.5l0.2-1.1l0,0c-0.6,0.8-1.5,1.3-2.6,1.3c-1.5,0-2.2-0.8-2.2-2c0-0.3,0-0.7,0.1-0.9l1-4.8h1.6 l-1,4.6c-0.1,0.2-0.1,0.5-0.1,0.7s-0.1,1.1,1.1,1.1c1.3,0,2.1-1.2,2.4-2.3l0.8-4h1.6L157.3,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M166,26.4h-1.6l0.2-1l0,0c-0.6,1-1.5,1.2-2.3,1.2c-0.9,0-2.9-0.3-2.9-3.1c0-2.4,1.5-4.8,4.1-4.8 c1,0,1.9,0.3,2.3,1.2l0,0l0.8-3.9h1.6L166,26.4z M163.7,20.1c-1.8,0-2.6,1.8-2.6,3.5c0,1.1,0.6,1.8,1.7,1.8c1.7,0,2.6-2,2.6-3.5 C165.3,20.9,164.8,20.1,163.7,20.1z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 162.5,
    y1: 29.2,
    x2: 74.5,
    y2: 29.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoScantripWhite);
export default __webpack_public_path__ + "static/media/logo_scantrip_white.36d94df8b121839ddce7117af8d14e9c.svg";
export { ForwardRef as ReactComponent };